import { CatalogPriceLinesZoneChecked } from "../models";
import { priceRequester as request } from "./requesters";

const catalogPriceLineZoneCheckedService = {
  createOrUpdateCatalogPriceLinesZoneChecked: (data: CatalogPriceLinesZoneChecked[]) =>
    request.post(`/catalog-price-lines-zone-checked`, { catalogPriceLinesZoneChecked: data }),
};
export default catalogPriceLineZoneCheckedService;
